import React from "react";
import PropTypes from "prop-types";
import RelativeLink from "../../common/RelativeLink";
import * as DomainConstants from "../../../constants/DomainConstants";

const VRValidationStatusList = ({ items, itemsFrontend, dossierType }) => {
    const route = {
        10: "voortgangsrapport/project",
        11: "voortgangsrapport/beoordelingscriteria",
        12: "voortgangsrapport/verantwoording"
    };

    function createUrl(tabnummer, voortgangsrapportId) {
        let url = "/" + route[tabnummer] + "/" + voortgangsrapportId;
        return url;
    }

    let ulStyle = {
        padding: '0 3.33333%',
        fontSize: '.875rem'
    };

    function compare(a, b) {
        if (a.tab < b.tab)
            return -1;
        if (a.tab > b.tab)
            return 1;
        return 0;
    }



    let sortedItems = [];
    Object.assign(sortedItems, items);
    sortedItems.sort(compare);

    itemsFrontend = itemsFrontend ? itemsFrontend : [];

    return (
        <ul style={ulStyle}>
            {sortedItems.map((item, i) => {
                let link = null;

                if (item.warnings > 0) {
                    let message = "";

                    if (item.opmerking) {
                        message = item.opmerking + " bij " + item.titel;
                    } else if (item.warnings == 1) {
                        message = item.warnings + " fout bij " + item.titel;
                    } else {
                        message = item.warnings + " fouten bij " + item.titel;
                    }

                    let url = createUrl(item.tab, item.master);


                    link = (<li key={i}>
                        <RelativeLink key={i} to={url} className={"minimal"}>{message}</RelativeLink>
                        <br />
                    </li>);
                }
                return link;
            })}

            {itemsFrontend.map((item, i) => {
                return (
                    <li key={i}>
                        <RelativeLink key={"frontend_warning" + i} to={item.url} className={"minimal"}>{item.text}</RelativeLink>
                        <br />
                    </li>
                );
            })}
        </ul>
    );
};

VRValidationStatusList.propTypes = {
    items: PropTypes.array,
    dossierType: PropTypes.number,
    itemsFrontend: PropTypes.array
};

export default VRValidationStatusList;